
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class NotFoundNuxt extends Vue {
  // Automaticly rendered by Nuxt on unknown route
  // https://nuxtjs.org/docs/features/file-system-routing/#unknown-dynamic-nested-routes

  created() {
    this.$router.replace(this.localePath({ name: 'slug-errors-code', params: { code: '404' } }));
  }
}
